module.exports = __webpack_public_path__ + "img/watermark_030046.dc3e84a0.png";